<section class="content-area-layout2">
    <h3>User Account</h3>
    <p class="text-aerostar-orange">{{message}}</p>
    <div mat-dialog-content>
        @if (userType == "employee") {
        <app-employee-component (messageEvent)="receiveMessage($event)"/>
        } @else if (userType == "dealer") {
        <app-dealer-component (messageEvent)="receiveMessage($event)"/>
        } @else if (userType == "dealer-rep") {
        <app-dealer-rep-component/>
        } @else if (userType == "customer") {
        <app-customer-component (messageEvent)="receiveMessage($event)"/>
        }
    </div>
    <div mat-dialog-actions>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            @if (userHasRole("account-editor")) {
            <button style="margin-right: 1vw;" mat-flat-button (click)="save()">Save</button>
            }
            <button mat-flat-button (click)="close()">Close</button>
        </section>
    </div>
</section>
